import React, { useEffect, useRef, useState } from 'react';
import { MyCampaignsImg } from '../../../static/constant/imgConstants';
import { useSelector } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CampaignDate.css"
import { IoChevronBack, IoChevronForward } from "react-icons/io5";


function CampaignDate({ startDate, endDate, errors, setStartDate, setEndDate, setErrors, type }) {
    const getAllConfigPropertiesForBrandAndInfluencerReducer = useSelector((state) => state.getAllConfigPropertiesForBrandAndInfluencerReducer);

    const [startDateDays, setStartDateDays] = useState();
    const [startDateDaysDif, setStartDateDaysDif] = useState();
    const datePickerRef = useRef(null);
    const endDatePickerRef = useRef(null);
    useEffect(() => {
        setStartDateDays(getAllConfigPropertiesForBrandAndInfluencerReducer?.data ? getAllConfigPropertiesForBrandAndInfluencerReducer?.data.filter((item) => item.type === type && item.name === 'start_date_threshold_in_days') : []);
        setStartDateDaysDif(getAllConfigPropertiesForBrandAndInfluencerReducer?.data ? getAllConfigPropertiesForBrandAndInfluencerReducer?.data.filter((item) => item.type === type && item.name === 'start_date_and_end_date_difference_in_days') : []);
    }, [getAllConfigPropertiesForBrandAndInfluencerReducer, type]);

    const startDateThresholdInDays = startDateDays ? Number(startDateDays[0]?.value) : 15;
    const startDateEndDateDifferenceInDays = startDateDaysDif ? Number(startDateDaysDif[0]?.value) : 20;

    const calculateMinDate = (offsetDays) => {
        if (!offsetDays || isNaN(offsetDays)) return null;
        const calculatedDate = new Date();
        calculatedDate.setDate(calculatedDate.getDate() + offsetDays);
        return calculatedDate.toISOString().split('T')[0];
    };

    const calculateEndDateMin = (start, offsetDays) => {
        if (!start || !offsetDays || isNaN(offsetDays)) return '';
        const startDateObj = new Date(start);
        if (isNaN(startDateObj)) return '';
        startDateObj.setDate(startDateObj.getDate() + offsetDays);
        return startDateObj.toISOString().split('T')[0];
    };

    return (<>
        <div className="w-full md:w-[49%] relative mb-[2rem]">
            <label className="text-[1.6rem] text-[#111729] inter-font font-[400] mb-1 leading-relaxed pb-2">
                Start Date<span className="text-[1.6rem] text-[#E3351D]">*</span>
            </label>
            <div className="relative mt-[1rem] ">
                {/*<input*/}
                {/*    type="date"*/}
                {/*    value={startDate}*/}
                {/*    onKeyDown={(e) => e.preventDefault()}*/}
                {/*    onChange={(e) => {*/}
                {/*        setStartDate(e.target.value);*/}
                {/*        setEndDate('');*/}
                {/*        setErrors((prevState) => {*/}
                {/*            const { ['startDate']: _, ...updatedObject } = prevState;*/}
                {/*            return updatedObject;*/}
                {/*        });*/}
                {/*        setErrors((prevState) => {*/}
                {/*            const { ['endDate']: _, ...updatedObject } = prevState;*/}
                {/*            return updatedObject;*/}
                {/*        });*/}
                {/*    }}*/}
                {/*    min={calculateMinDate(startDateThresholdInDays)}*/}
                {/*    className="w-full text-[1.6rem] text-[#111729] inter-font font-[400] border border-gray-300 rounded-lg p-4 pr-[3rem]"*/}
                {/*    id="startDate"*/}
                {/*/>*/}
                <DatePicker
                    id="startDate"
                    className="w-full !text-[1.6rem] md:!text-[2rem] text-[#111729] inter-font font-[400] border border-gray-300 rounded-lg p-4 pr-[3rem]"
                    minDate={calculateMinDate(startDateThresholdInDays)}
                    ref={datePickerRef}
                    selected={startDate}
                    onKeyDown={(e) => e.preventDefault()}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    onChange={(date) => {
                        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0));
                        setStartDate(utcDate.toISOString());
                        setEndDate('');
                        setErrors((prevState) => {
                            const { ['startDate']: _, ...updatedObject } = prevState;
                            return updatedObject;
                        });
                        setErrors((prevState) => {
                            const { ['endDate']: _, ...updatedObject } = prevState;
                            return updatedObject;
                        });
                    }}
                    shouldCloseOnSelect={true}
                    renderCustomHeader={({
                        monthDate,
                        customHeaderCount,
                        decreaseMonth,
                        increaseMonth
                    }) => {
                        const minDate = new Date(calculateMinDate(startDateThresholdInDays)); // Define minDate
                        const isPrevDisabled = monthDate <= new Date(minDate.getFullYear(), minDate.getMonth(), 1); // Disable if before minDate

                        return (
                            <div className="flex items-center justify-between">
                                <button
                                    aria-label="Previous Month"
                                    onClick={isPrevDisabled ? undefined : decreaseMonth}
                                    disabled={isPrevDisabled} // Disable button if before minDate
                                    className={isPrevDisabled ? "opacity-50 cursor-not-allowed" : ""}
                                >
                                    <IoChevronBack size={22} />
                                </button>
                                <span className="react-datepicker__current-month">
                                    {monthDate.toLocaleString("en-US", {
                                        month: "long", year: "numeric",
                                    })}
                                </span>
                                <button
                                    aria-label="Next Month"
                                    onClick={increaseMonth}
                                >
                                    <IoChevronForward size={22} />
                                </button>
                            </div>
                        );
                    }}
                />
                <img
                    src={MyCampaignsImg.calendarIcon}
                    alt="calendar"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer w-10 h-10"
                    onClick={() => {
                        if (datePickerRef.current) {
                            datePickerRef.current.setOpen(true); // Opens the DatePicker
                        }
                    }}
                />
            </div>
            {errors?.startDate && (<p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors?.startDate}
            </p>)}
        </div>
        <div className="w-full md:w-[49%] relative mb-[2rem]">
            <label className="text-[1.6rem] text-[#111729] inter-font font-[400] mb-1 leading-relaxed pb-2">
                End Date<span className="text-[1.6rem] text-[#E3351D]">*</span>
            </label>
            <div className="relative mt-[1rem]">
                {/*<input*/}
                {/*    type="date"*/}
                {/*    value={endDate}*/}
                {/*    onKeyDown={(e) => e.preventDefault()}*/}
                {/*    onChange={(e) => {*/}
                {/*        setEndDate(e.target.value);*/}
                {/*        setErrors((prevState) => {*/}
                {/*            const {['endDate']: _, ...updatedObject} = prevState;*/}
                {/*            return updatedObject;*/}
                {/*        });*/}
                {/*    }}*/}
                {/*    min={calculateEndDateMin(startDate, startDateEndDateDifferenceInDays)}*/}
                {/*    disabled={!startDate} // Disable end date until start date is selected*/}
                {/*    className={`w-full text-[1.6rem] text-[#111729] inter-font font-[400] border border-gray-300 rounded-lg p-4 pr-[3rem] ${!startDate ? 'bg-gray-100 cursor-not-allowed' : ''}`}*/}
                {/*    id="endDate"*/}
                {/*/>*/}
                <DatePicker
                    id="endDate"
                    className={`w-full !text-[1.6rem] md:!text-[2rem] text-[#111729] inter-font font-[400] border border-gray-300 rounded-lg p-4 pr-[3rem] ${!startDate ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                    minDate={calculateEndDateMin(startDate, startDateEndDateDifferenceInDays)}
                    ref={endDatePickerRef}
                    disabled={!startDate}
                    selected={endDate}
                    onKeyDown={(e) => e.preventDefault()}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    onChange={(date) => {
                        const localEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
                        setEndDate(localEndDate.toISOString());
                        setErrors((prevState) => {
                            const { ['endDate']: _, ...updatedObject } = prevState;
                            return updatedObject;
                        });
                    }}
                    shouldCloseOnSelect={true}
                    renderCustomHeader={({
                        monthDate,
                        customHeaderCount,
                        decreaseMonth,
                        increaseMonth
                    }) => {
                        const minDate = new Date(calculateEndDateMin(startDate, startDateEndDateDifferenceInDays)); // Define minDate
                        const isPrevDisabled = monthDate <= new Date(minDate.getFullYear(), minDate.getMonth(), 1); // Disable if before minDate

                        return (
                            <div className="flex items-center justify-between">
                                <button
                                    aria-label="Previous Month"
                                    onClick={isPrevDisabled ? undefined : decreaseMonth}
                                    disabled={isPrevDisabled} // Disable button if before minDate
                                    className={isPrevDisabled ? "opacity-50 cursor-not-allowed" : ""}
                                >
                                    <IoChevronBack size={22} />
                                </button>
                                <span className="react-datepicker__current-month">
                                    {monthDate.toLocaleString("en-US", {
                                        month: "long", year: "numeric",
                                    })}
                                </span>
                                <button
                                    aria-label="Next Month"
                                    onClick={increaseMonth}
                                >
                                    <IoChevronForward size={22} />
                                </button>
                            </div>
                        );
                    }}
                />
                <img
                    src={MyCampaignsImg.calendarIcon}
                    alt="calendar"
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer w-10 h-10"
                    onClick={() => {
                        if (!startDate) {
                            return;
                        } else {
                            if (endDatePickerRef.current) {
                                endDatePickerRef.current.setOpen(true); // Opens the DatePicker
                            }
                        }
                    }}
                />
            </div>
            {errors?.endDate && (<p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                {errors?.endDate}
            </p>)}
        </div>
    </>);
}

export default CampaignDate;
